import {setRedirect, setThemeDark, useUiStore} from '@/stores/ui-store';
import {QueryClientProvider} from '@tanstack/react-query';
import {router} from '@/router';
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';
import GlobalLoader from '@/components/global-loader';
import {TooltipProvider} from '@/components/ui/tooltip';
import {RouterProvider} from 'react-router-dom';
import GlobalConfirm from '@/components/global-confirm';
import {useEffect} from 'react';
import {Toaster} from '@/components/ui/sonner.tsx';
import {queryClient} from "@/services/query-client.ts";

function App() {
  const redirect = useUiStore(state => state.redirect);
  useEffect(() => {
    if (redirect) {
      const redirectFn = async (url: string) => {
        await router.navigate(url);
      };
      redirectFn(redirect).then(() => setRedirect(null)).catch(console.error);
    }
  }, [redirect]);
  useEffect(() => {
    setThemeDark();
  }, []);

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <RouterProvider router={router}/>
        </TooltipProvider>
        <ReactQueryDevtools initialIsOpen={false}/>
      </QueryClientProvider>
      <Toaster position="top-center" richColors/>
      <GlobalLoader/>
      <GlobalConfirm/>
    </>
  );
}

export default App;

